import React, { useState, useEffect, useRef } from "react";

const ScoreContent = ({ currentData, isSelected, onSelectAnswer }) => {
  const [hoverIndex, setHoverIndex] = useState(null);
  const isRenderedRef = useRef(false);

  useEffect(() => {
    // 페이지/데이터 변경 시 초기화
    setHoverIndex(null);
    isRenderedRef.current = false;

    // 단순히 300ms 후에 렌더링 완료로 간주
    const timer = setTimeout(() => {
      isRenderedRef.current = true;
    }, 300);

    return () => {
      clearTimeout(timer);
      isRenderedRef.current = false;
    };
  }, [currentData]);

  const handleMouseEnter = (index) => {
    // 렌더링이 완료된 상태에서만 호버 처리
    if (isRenderedRef.current) {
      setHoverIndex(index);
    }
  };

  const handleMouseLeave = () => {
    setHoverIndex(null);
  };

  return (
    <>
      <ul className={`score count_${currentData.question.items.length}`}>
        {currentData.question.items.map((item, index) => (
          <li
            key={`question-${index}`}
            className={`tooltip score-tooltip ${
              isSelected(item) ? "active" : ""
            }`}
            onClick={() => onSelectAnswer(item)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            {item.score}
            {item.content?.length > 0 && (
              <span
                className={`tooltiptext tooltip-top ${
                  hoverIndex === index ? "tooltip-visible" : ""
                }`}
              >
                {item.content}
              </span>
            )}
          </li>
        ))}
      </ul>
      <div>
        {currentData.question.items?.length > 0 &&
          currentData.question.items[0].score}
        점 : {currentData.question.items[0].content} &nbsp;-&nbsp;
        {currentData.question.items?.length > 0 &&
          currentData.question.items[currentData.question.items.length - 1]
            .score}
        점 :{" "}
        {
          currentData.question.items[currentData.question.items.length - 1]
            .content
        }
      </div>
    </>
  );
};

export default ScoreContent;
